import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import moment from 'moment';
import {TranslateService} from "@ngx-translate/core";
import {LoaderService} from "../../../api/loader.service";
import { CASE_STATUSES } from '../../../models/assistancecase';
import { Router } from '@angular/router';

@Component({
    selector: 'app-assistance-survey-graphs',
    templateUrl: './assistance-survey-graphs.component.html',
    styleUrls: ['./assistance-survey-graphs.component.css'],
    standalone: false
})
export class AssistanceSurveyGraphsComponent implements OnInit {
  answeredCasesData: any;
  answeredByData: any;
  averagePerGroupData: any;
  pointsPerServiceData: any;
  pointsPerProductData: any;
  pointsPerCountryData: any;
  pointsPerSponsorData: any;
  pointsPerCaseUser: any;
  totalAverageGroup: string;
  caseCountryId: number = null;
  caseProductId: number = null;
  casePlanId: number = null;
  caseSponsorId: number = null;
  caseUserId: number = null;
  caseDateStart: Date;
  caseDateEnd: Date;
  utcoffset: number;

  thisMonth: any;
  lastDayMonth: any;
  months = [];
  chartFormat: boolean[];
  graphOptions: any = [];
  userEvaluatedOptions: any;
  tooltipset: any = [];
  userEvaluatedToolTip: any;

  dateoption = {};
  labels: any;
  filter: any = {};
  backgroundColors: string[];
  downloadItems = [
    {value: 1, name: 'Image'},
    {value: 2, name: 'Report'}
  ];
  downloadItem: any;
  showDownloadDialog = false;
  showDialogDownloadReport = false;
  downloadReport = {
    file_type: 'csv',
    filter: {}
  };
  caseStatus = CASE_STATUSES;
  evaluationsOptions: any;

  // With response data build graphs
  @Input()
  set setResponseData(responseData) {
    if (responseData && responseData.length > 0) {
      this.drawAnsweredCase(responseData[0]);
      this.drawAnsweredBy(responseData[1]);
      this.drawAverageGroup(responseData[2]);
      this.drawPointsService(responseData[4]);
      this.drawPointsProduct(responseData[5]);
      this.drawPointsCountry(responseData[6]);
      this.drawPointsSponsor(responseData[7]);
      this.drawPointsCaseUser(responseData[8]);
    }
  }

  @Input()
  title: string;

  @Input()
  groupType: number;

  @Output('downloadReport')
  downloadReportEE: EventEmitter<any>;

  @Output('applyFilters')
  applyFiltersEE: EventEmitter<any>;

  constructor(
    private loaderService: LoaderService,
    private translate: TranslateService,
    private router: Router) {
    this.downloadReportEE = new EventEmitter();
    this.applyFiltersEE = new EventEmitter();

    this.chartFormat = Array(5).fill(false);
    this.tooltipset[0] = {
      displayColors: false,
      callbacks: {
        label: function (tooltipItem, data) {
          return;
        },
        title: function (tooltipItems, data) {
          // Return value for title
          const allData = data.datasets[tooltipItems[0].datasetIndex].data;
          const tooltipLabel = data.labels[tooltipItems[0].index];
          const tooltipData = allData[tooltipItems[0].index];
          let total = 0;
          for (let i in allData) {
            total += allData[i];
          }
          let tooltipPercentage = ((tooltipData / total) * 100);
          tooltipPercentage = Math.round(tooltipPercentage * 10) / 10;
          return tooltipLabel + ': ' + tooltipData + ' (' + tooltipPercentage + '%)';
        },
      },
      titleFontSize: 12,
      titleFontColor: '#FFF',
    };

    this.tooltipset[1] = {
      displayColors: false,
      callbacks: {
        label: function (tooltipItem, data) {
          return;
        },
        title: function (tooltipItems, data) {
          // Return value for title
          const allData = data.datasets[tooltipItems[0].datasetIndex].data;
          const average = data.datasets[tooltipItems[0].datasetIndex].average;
          const tooltipLabel = data.labels[tooltipItems[0].index];
          const tooltipData = allData[tooltipItems[0].index];
          return tooltipLabel + ': ' + tooltipData
            + ' (' + average[tooltipItems[0].index] + ')';
        },
      },
      titleFontSize: 12,
      titleFontColor: '#FFF',
    };

    this.tooltipset[2] = {
      displayColors: false,
      callbacks: {
        label: function (tooltipItem, data) {
          return;
        },
        title: function (tooltipItems, data) {
          // Return value for title
          const allData = data.datasets[tooltipItems[0].datasetIndex].data;
          const tooltipLabel = data.labels[tooltipItems[0].index];
          const tooltipData = allData[tooltipItems[0].index];
          const fixeddata = tooltipData.toFixed(1);
          return tooltipLabel + ': ' + fixeddata;
        },
      },
      titleFontSize: 12,
      titleFontColor: '#FFF',
    };

    this.userEvaluatedToolTip = {
      displayColors: false,
      callbacks: {
        label: function (tooltipItem, data) {
          return;
        },
        title: function (tooltipItems, data) {
          // Return value for title
          const allData = data.datasets[tooltipItems[0].datasetIndex].data;
          const totalCases = data.datasets[tooltipItems[0].datasetIndex].totalCases;
          const tooltipLabel = data.labels[tooltipItems[0].index];
          const tooltipData = allData[tooltipItems[0].index];
          return tooltipLabel + ': ' + tooltipData.toFixed(1)
            + ' (' + totalCases[tooltipItems[0].index] + ')';
        },
      },
      titleFontSize: 12,
      titleFontColor: '#FFF',
    };

    this.graphOptions[0] = {
      legend: {
        display: false,
        elements: {arc: {borderWidth: 0}}
      },
      segmentShowStroke: false,
      responsive: true,
      tooltips: this.tooltipset[0]
    };
    this.graphOptions[1] = {
      scales:
        {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            display: true,
            ticks: {
              min: 0,
            }
          }]
        },
      legend: {
        display: false,
        elements: {arc: {borderWidth: 0}}
      },
      segmentShowStroke: false,
      responsive: true,
      maintainAspectRatio: false,
      tooltips: this.tooltipset[0]
    };

    this.graphOptions[2] = {
      legend: {
        display: false,
        elements: {arc: {borderWidth: 0}}
      },
      segmentShowStroke: false,
      responsive: true,
      maintainAspectRatio: false,
      tooltips: this.tooltipset[1]
    };
    this.graphOptions[3] = {
      scales:
        {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            display: true,
            ticks: {
              min: 0,
            }
          }]
        },
      legend: {
        display: false,
        elements: {arc: {borderWidth: 0}}
      },
      segmentShowStroke: false,
      responsive: true,
      maintainAspectRatio: false,
      tooltips: this.tooltipset[1]
    };

    this.graphOptions[4] = {
      legend: {
        display: false,
        elements: {arc: {borderWidth: 0}}
      },
      segmentShowStroke: false,
      responsive: true,
      tooltips: this.tooltipset[2],
      maintainAspectRatio: false,
    };
    this.graphOptions[5] = {
      scales:
        {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            display: true,
            ticks: {
              min: 0,
            }
          }]
        },
      legend: {
        display: false,
        elements: {arc: {borderWidth: 0}}
      },
      segmentShowStroke: false,
      responsive: true,
      maintainAspectRatio: false,
      tooltips: this.tooltipset[2]
    };

    this.userEvaluatedOptions = {
      pie: Object.assign({}, this.graphOptions[4]),
      bar: Object.assign({}, this.graphOptions[5])
    }
    this.userEvaluatedOptions.pie.tooltips = this.userEvaluatedToolTip;
    this.userEvaluatedOptions.bar.tooltips = this.userEvaluatedToolTip;

    this.evaluationsOptions = {
      pie: Object.assign({}, this.graphOptions[0]),
      bar: Object.assign({}, this.graphOptions[1])
    };


    this.evaluationsOptions.pie.onClick = (evt, item) => {
      if (!item[0]) {
        return;
      }

      const params = this.getCasesBaseFilters();

      if (item[0]._index == 0) {
        // 0 is evaluated
        params['survey_evaluated'] = true;

        this.goToCases(params);
      } else {
        // 0 is evaluated
        params['survey_evaluated'] = false;

        this.goToCases(params);
      }
    };
    
    this.evaluationsOptions.bar.onClick = (evt, item) => {
      if (!item[0]) {
        return;
      }

      const params = this.getCasesBaseFilters();

      if (item[0]._index == 0) {
        // 0 is evaluated
        params['survey_evaluated'] = true;

        this.goToCases(params);
      } else {
        // 0 is evaluated
        params['survey_evaluated'] = false;

        this.goToCases(params);
      }
    };

    this.backgroundColors = [
      '#9edae5',
      '#17becf',
      '#dbdb8d',
      '#bcbd22',
      '#c7c7c7',
      '#7f7f7f',
      '#f7b6d2',
      '#e377c2',
      '#c49c94',
      '#8c564b',
      '#c5b0d5',
      '#9467bd',
      '#ff9896',
      '#d62728',
      '#98df8a',
      '#2ca02c',
      '#ffbb78',
      '#ff7f0e',
      '#aec7e8',
      '#1f77b4'
    ];

    this.labels = {
      'Price': 'Price',
      'Income': 'Income',
      'Planned': 'Planned',
      'Paid': 'Paid',
      'Last Month': 'Last Month',
      'Current Month': 'Current Month',
      'January': 'January',
      'February': 'February',
      'March': 'March',
      'April': 'April',
      'May': 'May',
      'June': 'June',
      'July': 'July',
      'August': 'August',
      'September': 'September',
      'October': 'October',
      'November': 'November',
      'December': 'December',
      'to': 'to',
      'Promoters': 'Promoters',
      'Liabilities': 'Liabilities',
      'Detractors': 'Detractors',
      'Excellent': 'Excellent',
      'Non-Excellent': 'Non-Excellent',
      'Answered2': 'Answered2',
      'Didn\'t Answer': 'Didn\'t Answer',
      'Today': 'Today',
      'Yesterday': 'Yesterday',
      'Last 7 Days': 'Last 7 Days',
      'Last 30 Days': 'Last 30 Days',
      'This Month': 'This Month',
      'Custom Range': 'Custom Range',
      'Apply': 'Apply',
      'Cancel': 'Cancel',
      'Su': 'Su',
      'Mo': 'Mo',
      'Tu': 'Tu',
      'We': 'We',
      'Th': 'Th',
      'Fr': 'Fr',
      'Sa': 'Sa'
    };
    const date = new Date();
    this.thisMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    this.lastDayMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    this.months[0] = this.labels['January'].substring(0, 3);
    this.months[1] = this.labels['February'].substring(0, 3);
    this.months[2] = this.labels['March'].substring(0, 3);
    this.months[3] = this.labels['April'].substring(0, 3);
    this.months[4] = this.labels['May'].substring(0, 3);
    this.months[5] = this.labels['June'].substring(0, 3);
    this.months[6] = this.labels['July'].substring(0, 3);
    this.months[7] = this.labels['August'].substring(0, 3);
    this.months[8] = this.labels['September'].substring(0, 3);
    this.months[9] = this.labels['October'].substring(0, 3);
    this.months[10] = this.labels['November'].substring(0, 3);
    this.months[11] = this.labels['December'].substring(0, 3);


    this.caseDateStart = this.thisMonth;
    this.caseDateEnd = this.lastDayMonth;
    this.utcoffset = new Date().getTimezoneOffset();
    this.translateLabels();
  }

  ngOnInit() {
    this.setSurveyGraph();
  }

  setDateRange(range) {
    this.caseDateStart = range.start._d;
    this.caseDateEnd = range.end._d;
    this.setSurveyGraph();
  }

  onFilters(filterdata) {
    this.caseCountryId = filterdata.country;
    this.caseProductId = filterdata.product;
    this.casePlanId = filterdata.plan;
    this.caseSponsorId = filterdata.sponsor;
    this.caseUserId = filterdata.user;
    this.setSurveyGraph();
  }

  translateLabels() {
    let lblTexts = [];

    for (let key in this.labels) {
      lblTexts.push(this.labels[key]);
    }

    this.translate.get(lblTexts)
      .subscribe((res: any) => {
        for (let key in res) {
          this.labels[key] = res[key];
        }

        this.configureDateOptions();
      });
  }

  configureDateOptions() {
    let ranges = {};

    ranges[this.labels['Today']] = [moment(), moment()];
    ranges[this.labels['Yesterday']] = [
      moment().subtract(1, 'days'), moment().subtract(1, 'days')
    ];
    ranges[this.labels['Last 7 Days']] = [
      moment().subtract(6, 'days'), moment()
    ];
    ranges[this.labels['Last 30 Days']] = [
      moment().subtract(29, 'days'), moment()
    ];
    ranges[this.labels['This Month']] = [
      moment().startOf('month'), moment().endOf('month')
    ];
    ranges[this.labels['Last Month']] = [
      moment().subtract(1, 'month').startOf('month'),
      moment().subtract(1, 'month').endOf('month')
    ];

    this.dateoption = {
      ranges: ranges,
      locale: {
        'format': 'DD/MM/YYYY',
        'applyLabel': this.labels['Apply'],
        'cancelLabel': this.labels['Cancel'],
        'customRangeLabel': this.labels['Custom Range'],
        'daysOfWeek': [
          this.labels['Su'],
          this.labels['Mo'],
          this.labels['Tu'],
          this.labels['We'],
          this.labels['Th'],
          this.labels['Fr'],
          this.labels['Sa']
        ],
        'monthNames': [
          this.labels['January'],
          this.labels['February'],
          this.labels['March'],
          this.labels['April'],
          this.labels['May'],
          this.labels['June'],
          this.labels['July'],
          this.labels['August'],
          this.labels['September'],
          this.labels['October'],
          this.labels['November'],
          this.labels['December'],
        ]
      }
    };
  }

  setSurveyGraph() {
    this.filter = {
      'country_id': this.caseCountryId,
      'sponsor_id': this.caseSponsorId,
      'assistance_id': this.caseProductId,
      'plan_id': this.casePlanId,
      'user_id': this.caseUserId,
      'from_date': this.dateToStr(this.caseDateStart),
      'to_date': this.dateToStr(this.caseDateEnd),
      'utcoffset': this.utcoffset,
      'group_type': this.groupType
    };
    this.applyFiltersEE.emit(this.filter);
  }

  dateToStr(date) {
    const date_str = date.getFullYear() + '-' + (date.getMonth() + 1)
      + '-' + date.getDate();
    return date_str;
  }

  drawAnsweredCase(items) {
    let label = [];
    let data = [];
    items.forEach(item => {
      this.translate.get(item[0]).subscribe(((res: string) => {
        label.push(res);
      }));
      data.push(item[1]);
    });

    // Get bg colors
    const bgColors = this.getColors(data.length);

    this.answeredCasesData = {
      labels: label,
      datasets: [
        {
          data: data,
          backgroundColor: bgColors,
          borderWidth: 0,
          hoverBackgroundColor: []
        }
      ]
    };
  }

  onDownload() {
    this.showDownloadDialog = false;
  }

  onDownloadCancel() {
    this.showDownloadDialog = false;
    this.showDialogDownloadReport = false;
  }

  downloadCsv() {
    this.showDialogDownloadReport = true;
    this.downloadReport = {
      file_type: 'csv',
      filter: {}
    };
  }

  saveDownloadReport() {
    this.downloadReport.filter = this.filter;
    this.downloadReportEE.emit(this.downloadReport);
    this.showDialogDownloadReport = false;
  }

  drawAnsweredBy(items) {
    let label = [];
    let data = [];
    items.forEach(item => {
      label.push(item[0]);
      data.push(item[1]);
    });

    // Get bg colors
    const bgColors = this.getColors(data.length);

    this.answeredByData = {
      labels: label,
      datasets: [
        {
          data: data,
          backgroundColor: bgColors,
          borderWidth: 0,
          hoverBackgroundColor: []
        }
      ]
    };
  }

  drawAverageGroup(items) {
    let label = [];
    let data = [];
    let average = [];
    let total_average = 0.0;
    items.forEach(item => {
      label.push(item[0]);
      data.push(item[1]);
      total_average += item[1];
      average.push(item[2]);
    });
    this.totalAverageGroup = (total_average / data.length).toFixed(2);
    // Get bg colors
    const bgColors = this.getColors(data.length);

    this.averagePerGroupData = {
      labels: label,
      datasets: [
        {
          average: average,
          data: data,
          backgroundColor: bgColors,
          borderWidth: 0,
          hoverBackgroundColor: []
        }
      ]
    };
  }

  drawPointsService(items) {
    let label = [];
    let data = [];
    const array_data = Object.keys(items).map(function(key) {
      return [key, items[key]];
    });
    array_data.forEach(item => {
      label.push(item[0]);
      const points = item[1][1] / item[1][0];
      data.push(points);
    });

    // Get bg colors
    const bgColors = this.getColors(data.length);

    this.pointsPerServiceData = {
      labels: label,
      datasets: [
        {
          data: data,
          backgroundColor: bgColors,
          borderWidth: 0,
          hoverBackgroundColor: []
        }
      ]
    };
  }

  drawPointsProduct(items) {
    let label = [];
    let data = [];
    const array_data = Object.keys(items).map(function(key) {
      return [key, items[key]];
    });
    array_data.forEach(item => {
      label.push(item[0]);
      const points = item[1][1] / item[1][0];
      data.push(points);
    });

    // Get bg colors
    const bgColors = this.getColors(data.length);

    this.pointsPerProductData = {
      labels: label,
      datasets: [
        {
          data: data,
          backgroundColor: bgColors,
          borderWidth: 0,
          hoverBackgroundColor: []
        }
      ]
    };
  }

  drawPointsCountry(items) {
    let label = [];
    let data = [];
    const array_data = Object.keys(items).map(function(key) {
      return [key, items[key]];
    });
    array_data.forEach(item => {
      label.push(item[0]);
      const points = item[1][1] / item[1][0];
      data.push(points);
    });

    // Get bg colors
    const bgColors = this.getColors(data.length);

    this.pointsPerCountryData = {
      labels: label,
      datasets: [
        {
          data: data,
          backgroundColor: bgColors,
          borderWidth: 0,
          hoverBackgroundColor: []
        }
      ]
    };
  }

  drawPointsSponsor(items) {
    let label = [];
    let data = [];
    const array_data = Object.keys(items).map(function(key) {
      return [key, items[key]];
    });
    array_data.forEach(item => {
      label.push(item[0]);
      const points = item[1][1] / item[1][0];
      data.push(points);
    });

    // Get bg colors
    const bgColors = this.getColors(data.length);

    this.pointsPerSponsorData = {
      labels: label,
      datasets: [
        {
          data: data,
          backgroundColor: bgColors,
          borderWidth: 0,
          hoverBackgroundColor: []
        }
      ]
    };
  }

  selectFormat(graph_id) {
    this.chartFormat[graph_id] = !this.chartFormat[graph_id];
  }

  getColors(total) {
    const lenBgColors = this.backgroundColors.length;
    if (this.backgroundColors == null || lenBgColors == 0) {
      return [];
    }

    let colors = [];
    let currentIndex = 0;

    // If total is > total, repeat colors
    for (let i = 0; i < total; ++i) {
      if (currentIndex >= lenBgColors) {
        currentIndex -= lenBgColors;
      }

      colors.push(this.backgroundColors[currentIndex]);
      currentIndex++;
    }

    return colors;
  }

  drawPointsCaseUser(items) {
    let label = [];
    let data = [];
    let totalCases = [];
    const array_data = Object.keys(items).map(function(key) {
      return [key, items[key]];
    });
    array_data.forEach(item => {
      const username = item[0];
      const casesCount = item[1][0];
      const totalPoints = item[1][1];
      const average = totalPoints / casesCount;
      label.push(username);
      data.push(average);
      totalCases.push(casesCount);
    });

    // Get bg colors
    const bgColors = this.getColors(data.length);

    this.pointsPerCaseUser = {
      labels: label,
      datasets: [
        {
          totalCases: totalCases,
          data: data,
          backgroundColor: bgColors,
          borderWidth: 0,
          hoverBackgroundColor: []
        }
      ]
    };
  }

  getCasesBaseFilters() {
    return {
      group_type: this.groupType,
      from_date: this.filter.from_date,
      to_date: this.filter.to_date,
      status: CASE_STATUSES.STATUS_CLOSE
    };
  }

  goToCases(params) {
    this.router.navigate(
      ['/admin/assistance/cases'],
      {
        queryParams: params
      }
    );
  }
}
